<template>
    <div class="con-btn">
        <div class="column-layout flex">
            <div class="form-single">
                <div class="title required">通知标题</div>
                <div><span>{{servicerNotice.title}}</span></div>
            </div>
            <div class="form-single" v-if="showTag == null || showTag">
                <div class="title required">通知对象</div>
                <div class="content">
                    <el-table :data="servicerNoticeTargets" style="width: 100%" border height="250">
                        <el-table-column prop="comName" label="公司"></el-table-column>
                        <el-table-column prop="departName" label="部门">
                            <template slot-scope="rows">
                                <span v-if="rows.row.departId != null && rows.row.departId != -1">{{rows.row.departName}}</span>
                                <span v-else>全部</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="postName" label="岗位">
                            <template slot-scope="rows">
                                <span v-if="rows.row.postId != null && rows.row.postId != -1">{{rows.row.postName}}</span>
                                <span v-else>全部</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="form-single">
                <div class="title required">内容简介</div>
                <div class="content">
                    <el-input type="textarea" :disabled="noEditor == null ? false: noEditor" v-model="servicerNotice.digest"></el-input>
                </div>
            </div>
            <div class="form-single">
                <div class="title required">内容信息</div>
                <div class="content">
                    <swb-ck-editor ref="theCkEditor" :content="content" :imageXtHandler="imageXtHandler"></swb-ck-editor>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-servicer-notice-view',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '通知制作',
        props: ["id",'showTag','noEditor'],
        data: function () {
            let self = this;
            return {
                imageXtHandler: function (ckEditor) {
                    //
                    self.showDialogIntroImg(ckEditor);
                },
                servicerNotice: {},
                servicerNoticeTargets: [],
                content: null,
            }
        },
        created: function () {

            let id = this.id || null;
            if(!Utils.isNoB(id)) {
                this.getRetailerNotice(id);
            }
        },
        methods: {

            getRetailerNotice: function (id) {
                let self = this;
                let postData = {
                    id: id
                };
                servicerApi.getServicerNotice(postData, function (result) {
                    if(result.type == "info") {
                        let servicerNotice = result.data;
                        let servicerNoticeTargets = servicerNotice.servicerNoticeTargetList;
                        self.servicerNotice = servicerNotice;
                        self.servicerNoticeTargets = servicerNoticeTargets;
                        self.content = servicerNotice.content;
                    }
                })
            },
            send: function (noticeId) {
                let self = this;
                let postData = {
                    id: noticeId
                }
                servicerApi.sendRetailerNotice(postData, function (result) {
                    if(result.type == "info") {
                        MsgBox.success("发送成功")
                        self.getRetailerNotice(noticeId);
                    } else {
                        MsgBox.warning("发送失败")
                    }
                })
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/servicer/ServicerNoticeView.vue